import { useEffect, useRef } from 'react'
import { router } from '@inertiajs/react'
import consumer from '@/channels/consumer'

/**
 * Subscribes to Tasks::BoardChannel for all given board IDs.
 * On any task change (created, updated, deleted), triggers a debounced
 * Inertia partial reload of the tasks prop.
 */
export function useAllBoardChannels(boardIds: number[]) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const subscriptions = boardIds.map((boardId) =>
      consumer.subscriptions.create(
        { channel: 'Tasks::BoardChannel', board_id: boardId },
        {
          received() {
            if (timerRef.current) clearTimeout(timerRef.current)
            timerRef.current = setTimeout(() => {
              router.reload({ only: ['tasks'] })
            }, 500)
          },
        }
      )
    )

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
      subscriptions.forEach((sub) => sub.unsubscribe())
    }
  }, [boardIds.join(',')])
}
